/* eslint-disable no-mixed-operators */
import React, {
 memo, useState, useEffect, useMemo 
} from 'react';
import _ from 'lodash';
import { Button } from 'components';
import { decodeToken } from 'utils/helper';
import {
  applicantDetailById,
  applicantMoStatus,
  saveApplicantMoStatus,
  uploadAssetAllocationPDF,
  uploadCustomSubPfPDF,
  selectItem,
  saveApplicantData,
  uploadPassportAndCivilID,
  getUploadedCustomFilesAction,
  getCustomfileByNameAction,
  deleteCustomfileByNameAction,
  toggleCRNAction,
} from 'shared/context/actions';
import { useIntl } from 'react-intl';
import connect from 'shared/context/connect';
import {
  CONST_RETAIL_APPLICANT,
  APP_STATUS,
  APP_STATUS_MAPPING,
} from 'shared/constants';
import { getDashboardUserById, getPaymentHistory } from 'shared/services/api';

import Information from './Information';
import DocumentFiles from './DocumentFiles';
import FormsApp from './FormsApp';

import './styles/ManageApplication.scss';

interface Props {
  intl?: { formatMessage };
  detail;
  clientData;
  onUpdateApplicantStatus;
  onGetFilePdfAction;
  onGetImageAction;
  onGetPDFSimulationAction;
  onGetApplicantDetailById;
  onSaveApplicantMoStatus;
  onGetApplicantMoStatus;
  onUploadAssetAllocationPDF;
  onUploadCustomSubPfPDF;
  onSelectItem;
  onSaveApplicantData;
  onUploadPassportAndCivilID;
  onGetUploadedCustomFilesAction;
  onGetCustomfileByNameAction;
  onDeleteCustomfileByNameAction;
  onToggleCRNAction;
  // detailStore;
}

const ManageApplication: React.FC<Props> = memo(
  ({
    intl: { formatMessage },
    detail,
    onUpdateApplicantStatus,
    onGetFilePdfAction,
    onGetPDFSimulationAction,
    onUploadAssetAllocationPDF,
    onUploadCustomSubPfPDF,
    onGetImageAction,
    clientData,
    onGetApplicantDetailById = () => {},
    onSaveApplicantMoStatus = () => {},
    onSaveApplicantData = () => {},
    onGetApplicantMoStatus = () => {},
    onSelectItem = () => {},
    onUploadPassportAndCivilID = () => {},
    onGetUploadedCustomFilesAction = () => {},
    onGetCustomfileByNameAction = () => {},
    onDeleteCustomfileByNameAction = () => {},
    onToggleCRNAction = () => {},
    // detailStore,
  }) => {
    const {
      SELECT_BOX: { REWORK },
      STATUS: {
        AGREEMENT_SIGNED, UNDER_REVIEW, APPROVED, AGREEMENT_READY,
      },
    } = CONST_RETAIL_APPLICANT;
    const intl = useIntl();
    const [state, setState] = useState(null);
    const [crn, setCrn] = useState('');
    const [isCRNsaved, setIsCRNsaved] = useState(false);
    const [idPassport, setIdPassport] = useState(null);
    const [clientDetail, setClientDetail] = useState(null);
    const [isRequiredIdsUploaded, SetIsRequiredIdsUploaded] = useState(false);
    // const [isCivilIdPassportAvailable, setIsCivilIdPassportAvailable] = useState(true);
    
    const { assetAllocationAvailable, customSubPfAvailable, proofOfTransferAvailable } = detail;
    // console.log(':::::assetAllocationAvailable:::', assetAllocationAvailable);

    // /** @todo make all as qualified client for now and revert it on 31 Dec 2023 */
    /** @note activated again to not make all as qualified client */
    const isQualifield = detail.clientClassification === 'NW-MAR-CLA-QUA';

    //* * SIGNED */
    const [isSigned, setIsSigned] = useState(false);
    const [isFirstOneSigned, setFirstOneSigned] = useState(false);

    const [paymentDataStatus, setPaymentDataStatus] = useState({});

    // Get payment status
    const getPaymentStatus = React.useCallback(async (token, username) => {
      try {
        const filteredUsername = username.find((item: any) => item.primary === true);
        const res = await getPaymentHistory(token, filteredUsername.phoneNumber.slice(1));
        if (res && Array.isArray(res) && res.length) {
          const getLatestPaymentItem = res.reduce((a, b) => (a.paidOn > b.paidOn ? a : b));
          setPaymentDataStatus(getLatestPaymentItem);
        }
      } catch (err) {
        console.error(err);
      }
    }, []);

    /**
     * Manage readonly based on Role
     */
    const isReadOnly = useMemo(() => {
      const { userRoles } = decodeToken(clientData?.token);
      const readOnlyRole = 'MARKAZ_COMPLIANCE_OFFICER';
      return userRoles.includes(readOnlyRole);
    }, [clientData]);

    const isDownloadable = useMemo(() => {
      const { userRoles } = decodeToken(clientData?.token);
      const downloableRoles = ['MARKAZ_COMPLIANCE_OFFICER', 'ROLE_ADMIN', 'MARKAZ_ADMIN', 'MARKAZ_CLIENT_ADMIN_OFFICER'];
      return userRoles.some((r) => downloableRoles.includes(r));
    }, [clientData]);

    useEffect(() => {
      if (clientData.token && detail.applicantPhoneNumbers?.length) {
        getPaymentStatus(clientData.token, detail.applicantPhoneNumbers);
      }
    }, [clientData.token, detail.applicantPhoneNumbers, getPaymentStatus]);

    useEffect(() => {
      if (detail.id) {
        const ApplicantID = detail.id;

        /** Set isRequiredIdsUploaded to TRUE if available or uploaded on the back  */
        if (detail.civilIdFrontAvailable && detail.civilIdBackAvailable && detail.passportAvailable) {
          SetIsRequiredIdsUploaded(true);
        }

        Promise.all([
          onGetApplicantMoStatus(ApplicantID),
          onGetApplicantDetailById(ApplicantID),
        ]).then((res) => {
          if (res) {
            const [dataMo, dataDetail] = res;
            if (dataDetail) {
              onToggleCRNAction(dataDetail.customCrn);
              setClientDetail({
                ...dataDetail.clientDetails,
                paciFrontStatus: dataDetail?.paciFrontStatus,
                lang: dataDetail.lang,
              });
            }

            // onToggleCRNAction(dataDetail)
            if (
              dataDetail && dataDetail.crnNumber
            ) {
              setCrn(dataDetail.crnNumber);
              setIsCRNsaved(true);
            }

            if (dataDetail && dataDetail.idAndPassport) {
              setIdPassport(dataDetail.idAndPassport);
            }

            if (dataMo) {
              let dataUpdate = dataMo;
              if (dataDetail && dataDetail.agreements !== null) {
                const {
                  agreements: {
                    aofKycProfileSignature,
                    ndpfProposedPlanSignature,
                    ndpfProposedPlanTimestamp,
                  },
                } = dataDetail;
                setFirstOneSigned(
                  !aofKycProfileSignature || aofKycProfileSignature === '',
                );
                // eslint-disable-next-line
                if (
                  aofKycProfileSignature
                  && aofKycProfileSignature !== ''
                  && ndpfProposedPlanSignature
                  && ndpfProposedPlanSignature !== ''
                ) {
                  // eslint-disable-next-line
                  setIsSigned(true);

                  // Check if signed show under review status
                  let adminStatusAgreements = dataMo.agreements.adminStatus;
                  if (adminStatusAgreements !== null) {
                    const agreementAdminStatus = adminStatusAgreements.status;
                    if (
                      agreementAdminStatus !== APPROVED
                      && agreementAdminStatus !== REWORK
                    ) {
                      adminStatusAgreements = {
                        ...adminStatusAgreements,
                        status: UNDER_REVIEW,
                        title: intl.formatMessage({
                          id: 'manageApplication.markazAdminStatus',
                        }),
                      };
                    }
                  } else {
                    adminStatusAgreements = {
                      ...adminStatusAgreements,
                      status: UNDER_REVIEW,
                      title: intl.formatMessage({
                        id: 'manageApplication.markazAdminStatus',
                      }),
                    };
                  }

                  // console.log('adminStatusAgreements', adminStatusAgreements);
                  dataUpdate = {
                    ...dataMo,
                    agreements: {
                      ...dataMo.agreements,
                      adminStatus: adminStatusAgreements,
                      signedStatus: {
                        ...dataMo.agreements.adminStatus,
                        status: AGREEMENT_SIGNED,
                        statusDetail: ndpfProposedPlanTimestamp * 1000,
                      },
                    },
                  };
                }
              }
              setState({ ...dataUpdate });
            }
          }
        });
      }
      // eslint-disable-next-line
    }, [detail.id]);

    const phone = (detail.applicantPhoneNumbers
        && _.first(detail.applicantPhoneNumbers).phoneNumber)
      || '';

    const resetMOstatus = () => {
      const ApplicantID = detail.id;
      onGetApplicantMoStatus(ApplicantID).then((res) => {
        const dataMo = res;
        if (
          dataMo
          && dataMo.agreements
          && dataMo.agreements.agreements
          && dataMo.agreements.agreements.status === AGREEMENT_READY
        ) {
          const dataUpdate = {
            ...state,
            agreements: {
              ...state.agreements,
              agreements: {
                ...state.agreements.adminStatus,
                status: AGREEMENT_READY,
              },
            },
          };
          setState({ ...dataUpdate });
        }
      });
    };

    const handleUpdateData = async (dataUpdate) => {
      const dataClone = { ...state };
      const dataPost = { ...dataClone, ...dataUpdate };
      if (dataPost) {
        await onSaveApplicantMoStatus(detail.id, dataPost);
        // setState(dataPost);
        // resetMOstatus();
        const ApplicantID = detail.id;
        onGetApplicantMoStatus(ApplicantID).then((res) => {
          const dataMo = res;
          // if (dataMo && dataMo.agreements && dataMo.agreements.agreements
          //      && dataMo.agreements.agreements.status === AGREEMENT_READY) {
          //   const dataUpdate = {
          //     ...state,
          //     agreements: {
          //       ...state.agreements,
          //       agreements: {
          //         ...state.agreements.adminStatus,
          //         status: AGREEMENT_READY,
          //       },
          //     },
          //   };
          setState({ ...dataMo });
          // }
        });
      }
    };

    // const [assetAllocationAvailableState, setAssetAllocationAvailableState] = useState(assetAllocationAvailable);

    useEffect(() => {
      // console.log('state123', state, assetAllocationAvailableState, isQualifield);
      if (state !== null && isQualifield && assetAllocationAvailable) {
        resetMOstatus();
        // setAssetAllocationAvailableState(assetAllocationAvailable);

        // const dataUpdate = {
        //   ...state,
        //   agreements: {
        //     ...state.agreements,
        //     agreements: {
        //       ...state.agreements.adminStatus,
        //       status: AGREEMENT_READY,
        //     },
        //   },
        // };
        // setState({ ...dataUpdate });
      }
      // eslint-disable-next-line
    }, [assetAllocationAvailable]);

    const [applicantStatus, setDetail] = useState(detail.applicantStatus);
    const handleUpdateInput = (dataUpdate) => {
      setDetail({
        ...applicantStatus,
        ...dataUpdate,
        status: APP_STATUS.COMPLETED,
        applicantId: detail.id,
      });
    };

    const onUpdateStatus = (value) => {
      let status = null;
      let name = null;
      switch (value) {
        case 'completed':
          status = APP_STATUS.COMPLETED;
          name = APP_STATUS_MAPPING[APP_STATUS.COMPLETED];
          break;
        case 'cancelled':
          status = APP_STATUS.CANCELLED;
          name = APP_STATUS_MAPPING[APP_STATUS.CANCELLED];
          break;
        case 'ongoing':
          status = APP_STATUS.ONGOING;
          name = APP_STATUS_MAPPING[APP_STATUS.ONGOING];
          break;
        default:
          break;
      }

      if (!name) {
        return;
      }
      setDetail({
        ...applicantStatus,
        status,
        statusName: name,
      });
      setState((prev) => ({ ...prev, overallStatus: value }));
    };

    //* * UPDATE DATA */
    const handleUpdateApp = async () => {
      onUpdateApplicantStatus(applicantStatus);
      await onSaveApplicantMoStatus(detail.id, state);
      // const rs =
      await onSaveApplicantData(detail.id, { crn });
      // do this because when we clear the current
      // selected item with onSelectItem, the popup hasn't been closed yet
      // it will show worng data before closed
      setTimeout(() => {
        onSelectItem();
      }, 600);
    };

    /** function to determine if admin can continue or not depending if there are civil ids and passport uploaded */
    // const isContinueApplicationDisabled = () => {
    //   if (detail.civilIdFrontAvailable && detail.civilIdBackAvailable && detail.passportAvailable) {
    //     return false;
    //   }
    //   return true;
    // };
    const crmFatcaCrsStatus = state && state.crmFatcaCrs && state.crmFatcaCrs.applicantForms && state.crmFatcaCrs.applicantForms.status === 'complete';

    /**
     * Handle Uploading of IDs, passport & photos and update isRequiredIds state
     * to TRUE if civil id (front & back) are uploaded
     * */
    const onHandleUploadIDs = async (file, type, callback) => {
      const res = await onUploadPassportAndCivilID(file, type, callback);
      if (res) {
        const userDetail = await getDashboardUserById(clientData.token, detail.id);
        const { civilIdFrontAvailable, civilIdBackAvailable, passportAvailable } = userDetail.data;
        // console.log('UPLOAD SUCCESS ', res, userDetail.data);
        if (civilIdFrontAvailable && civilIdBackAvailable && passportAvailable) {
          SetIsRequiredIdsUploaded(true);
        }
      }
    };

    if (detail) {
      return (
        <article className="ManageApplication">
          <section className="ManageApplication__aside">
            <div className="ManageApplication__aside__sideBar">
              <aside className="ManageApplication__aside__header__files">
                <Information detail={detail} phone={phone} paciDetail={clientDetail?.paciFrontStatus} />
                <h6>
                  {formatMessage({
                    id: 'dashboard.updateApp.downloadDocument',
                  })}
                </h6>
                <DocumentFiles
                  idAndPassport={idPassport}
                  isFirstOneSigned={isFirstOneSigned}
                  detail={detail}
                  phone={phone}
                  lang={clientDetail?.lang}
                  onGetFilePdfAction={onGetFilePdfAction}
                  onGetPDFSimulationAction={onGetPDFSimulationAction}
                  onGetImageAction={onGetImageAction}
                  onUploadAssetAllocationPDF={onUploadAssetAllocationPDF}
                  onUploadCustomSubPfPDF={onUploadCustomSubPfPDF}
                  onUploadPassportAndCivilID={(file, type, callback) => onHandleUploadIDs(file, type, callback)}
                  token={clientData.token}
                  isQualifield={isQualifield}
                  assetAllocationAvailable={assetAllocationAvailable}
                  customSubPortfolioAvailable={customSubPfAvailable}
                  onGetUploadedCustomFilesAction={onGetUploadedCustomFilesAction}
                  onGetCustomfileByNameAction={onGetCustomfileByNameAction}
                  onDeleteCustomfileByNameAction={onDeleteCustomfileByNameAction}
                  isDisabled={!isDownloadable}
                  proofOfTransferAvailable={proofOfTransferAvailable}
                />
              </aside>
            </div>
            <div className="ManageApplication__aside__content">
              {/* {console.log('STATE ++++ ', state)} */}
              <FormsApp
                crn={crn}
                onUpdateCRN={setCrn}
                isCRNsaved={isCRNsaved}
                isNeitherRetailNorQualified={
                  !detail
                  || !detail.clientClassification
                  || detail.clientClassification === ''
                }
                isSigned={isSigned}
                isFirstOneSigned={isFirstOneSigned}
                data={state}
                onUpdateData={handleUpdateData}
                onUpdateInput={handleUpdateInput}
                onUpdateStatus={onUpdateStatus}
                applicantStatus={applicantStatus}
                isQualifield={isQualifield}
                assetAllocationAvailable={assetAllocationAvailable}
                customSubPortfolioAvailable={customSubPfAvailable}
                clientDetail={clientDetail}
                isDisabled={(!isRequiredIdsUploaded && crmFatcaCrsStatus) || isReadOnly}
                paymentData={paymentDataStatus}
              />
            </div>
          </section>
          <section className="ManageApplication__footer">
            {!isRequiredIdsUploaded && crmFatcaCrsStatus ? <span className="notification">Warning: This application should have civil ID (front/back) and passport uploaded in order to complete the process.</span> : <span />}
            <Button
              isBig
              value={formatMessage({ id: 'dashboard.updateApp.update' })}
              onButtonClick={handleUpdateApp}
              isDisabled={isReadOnly}
            />
          </section>
        </article>
      );
    }
    return <></>;
  },
);

const mapStateToProps = ({ rootState, dashboard }) => ({
  clientData: rootState.clientData,
  detailStore: dashboard.detail,
});

const mapDispatchToProps = {
  onGetApplicantDetailById: applicantDetailById,
  onGetApplicantMoStatus: applicantMoStatus,
  onSaveApplicantMoStatus: saveApplicantMoStatus,
  onSaveApplicantData: saveApplicantData,
  onUploadAssetAllocationPDF: uploadAssetAllocationPDF,
  onUploadCustomSubPfPDF: uploadCustomSubPfPDF,
  onUploadPassportAndCivilID: uploadPassportAndCivilID,
  onGetUploadedCustomFilesAction: getUploadedCustomFilesAction,
  onSelectItem: selectItem,
  onGetCustomfileByNameAction: getCustomfileByNameAction,
  onDeleteCustomfileByNameAction: deleteCustomfileByNameAction,
  onToggleCRNAction: toggleCRNAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageApplication);
